<template>
  <v-card :style="backOpacity">
    <v-card-title>表示切替フォーム</v-card-title>
    <v-card-text>
      <v-container>
        <v-row> rules:{{ rules }}</v-row>
        <v-row>
          **必ず先頭に配置し、divで1行を囲って表示・非表示を切り替える</v-row
        >
        <v-row>
          <v-col cols="4">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              :rules="[varidation.required]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-model="rules[5]"
              label="タグ表示"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-text-field
              label="横幅"
              v-model="returnData.cols"
              :disabled="rules[5] == null"
              :rules="[varidation.cols, varidation.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="4" v-if="false">
            <v-text-field
              label="範囲指定"
              v-model="rules[0]"
              :rules="[varidation.numonly, varidation.required]"
            ></v-text-field>
            *0だと1行 自身含むn個を囲む
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-checkbox
              v-model="rules[7]"
              label="v-showへの切り替え"
              value="true"
            ></v-checkbox>
            *マスタデータが配下のサブページに含まれる場合、バグがでるため使用
          </v-col>
          <v-col v-if="rules[5] != null && rules[5] != ''" cols="4">
            <v-select
              :items="$store.state.colors"
              :background-color="rules[6]"
              item-text="label"
              item-value="value"
              v-model="rules[6]"
              label="ラベル色"
            ></v-select>
          </v-col>
        </v-row>
        <hr />
        <!-------------- ------------>
        {{ joinTerms }}
        *{}で囲むとX文字列を含む場合 *notNull で対象フォームIDが空でない時
        *isNull で対象フォームIDの時
        <div v-for="(term, i) in joinTerms" :key="`1-${i}`" class="mb-4">
          <v-row>
            <v-col cols="2">
              <div v-if="i != 0">
                <v-select
                  :items="joinTerm"
                  v-model="joinTerms[i]"
                  label="AND OR"
                  :rules="[varidation.required]"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="selectclickTerms"
                v-model="clickTerms[i]"
                label="条件"
                item-text="label"
                item-value="value"
                :rules="[varidation.required]"
              ></v-select>
            </v-col>
            <v-col cols="2" v-if="clickTerms[i] == 'role'">
              <v-select
                label="権限レベル"
                :rules="[]"
                v-model="clickTermValues[i]"
                item-text="label"
                item-value="value"
                :items="selectRole"
              ></v-select>
            </v-col>
            <v-col
              cols="2"
              v-else-if="
                clickTerms[i] == 'formID' || clickTerms[i] == 'UserformID'
              "
            >
              <v-text-field
                label="条件対象formID"
                :rules="[varidation.numonly]"
                v-model="clickTermValues[i]"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="3"
              v-if="clickTerms[i] == 'formID' || clickTerms[i] == 'UserformID'"
            >
              <v-text-field
                label="if == X"
                :rules="[]"
                v-model="clickTermCondition[i]"
                required
              ></v-text-field>
              *先頭に!で !=
            </v-col>
          </v-row>
        </div>

        <!-------------------------------------->
        <v-row>
          <v-col cols="1">
            <v-btn @click="add1" class="ma-2">追加</v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn @click="del1" class="ma-2">削除</v-btn>
          </v-col></v-row
        >
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        x-large
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    label: String,
    type: Number,
    cols: Number,
    position: Number,
    //個別値
    value: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        cols: this.cols,
        position: this.position,
        //個別値
        value: this.value,
        rule: this.rule,
      },
      backOpacity: "opacity: 1",
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      //個別値
      rules: [],
      joinTerms: [],
      clickTerms: [],
      clickTermValues: [],
      clickTermCondition: [],
      //
      joinTerm: ["AND", "OR", "AND(", "OR(", "AND)", "OR)"],
      selectclickTerms: [
        { label: "ユーザ権限", value: "role" },
        { label: "特定フォーム値", value: "formID" },
        { label: "ユーザ情報の特定フォーム値", value: "UserformID" },
      ],
      selectRole: [
        { label: "一般", value: "0" },
        { label: "管理者", value: "1" },
        { label: "第3属性", value: "2" },
      ],
    };
  },
  mounted() {
    if (this.rule != "" || typeof this.rule == "undefined") {
      this.rules = this.rule.split(",");
    }
    if (this.rules.length > 3 && this.rules[2] != "") {
      this.joinTerms = this.rules[1].split(":");
      this.clickTerms = this.rules[2].split(":");
      this.clickTermValues = this.rules[3].split(":");
      this.clickTermCondition = this.rules[4].split(":");
    }
  },
  methods: {
    submit() {
      this.rules[1] = this.joinTerms.join(":");
      this.rules[2] = this.clickTerms.join(":");
      this.rules[3] = this.clickTermValues.join(":");
      this.rules[4] = this.clickTermCondition.join(":");
      if (this.rules[5] == null) {
        this.rules[6] == "";
      }
      this.returnData.rule = this.rules.join(",");
      //
      this.$emit("clickSubmit", this.returnData);
    },
    add1() {
      let i = this.joinTerms.length - 1;
      this.joinTerms.push(this.joinTerms[i]);
      this.clickTerms.push(this.clickTerms[i]);
      this.clickTermValues.push(this.clickTermValues[i]);
      this.clickTermCondition.push(this.clickTermCondition[i]);
    },
    del1() {
      if (this.joinTerms.length > 0) {
        this.joinTerms.splice(-1, 1);
        this.clickTerms.splice(-1, 1);
        this.clickTermValues.splice(-1, 1);
        this.clickTermCondition.splice(-1, 1);
      }
    },
  },
};
</script>
